{
  "version": 1,
  "asset_id": "20539e37-49db-4b3d-8add-36c0f588d950",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/20539e37-49db-4b3d-8add-36c0f588d950/blog-default-1280.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/20539e37-49db-4b3d-8add-36c0f588d950/blog-default-1280.webp",
  "original_filename": "blog-default-1280.webp",
  "size": 110428,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:25:51Z"
}
